import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import PublicLayout from "./components/PublicLayout";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import PartsPage from "./pages/PartsPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import ServicesPage from "./pages/ServicesPage";
import BookingPage from "./pages/BookingPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCustomers from "./pages/AdminCustomers";
import AdminRepairs from "./pages/AdminRepairs";
import AdminReservations from "./pages/AdminReservations";
import AdminSmsLog from "./pages/AdminSmsLog";
import RepairPrintPage from "./pages/RepairPrintPage";
import AdminCustomerDetail from "./pages/AdminCustomerDetail";
import AdminReports from "./pages/AdminReports";
import AdminCalendar from "./pages/AdminCalendar";
import AdminParts from "./pages/AdminParts";
import AdminUsers from "./pages/AdminUsers";
import AdminActivityLog from "./pages/AdminActivityLog";
import AdminWarranties from "./pages/AdminWarranties";
import WarrantyPrintPage from "./pages/WarrantyPrintPage";
import WarrantyBoxSheetPage from "./pages/WarrantyBoxSheetPage";
import AdminScanMode from "./pages/AdminScanMode";
import AdminScanTest from "./pages/AdminScanTest";
import AdminSales from "./pages/AdminSales";
import AdminProducts from "./pages/AdminProducts";
import AdminOrders from "./pages/AdminOrders";
import BarcodeLabelPage from "./pages/BarcodeLabelPage";
import SalePrintPage from "./pages/SalePrintPage";
import InvoicePrintPage from "./pages/InvoicePrintPage";
import AdminInvoices from "./pages/AdminInvoices";
import ManualInvoicePrintPage from "./pages/ManualInvoicePrintPage";
import PublicRepairStatus from "./pages/PublicRepairStatus";
import WarrantyCheckPage from "./pages/WarrantyCheckPage";

function App() {
  return (
    <div className="App font-body bg-[#050505] text-white min-h-screen">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/magazin" element={<ShopPage />} />
              <Route path="/piese" element={<PartsPage />} />
              <Route path="/produs/:id" element={<ProductPage />} />
              <Route path="/cos" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/servicii" element={<ServicesPage />} />
              <Route path="/programare" element={<BookingPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>

            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/reparatii/:id/print" element={<RepairPrintPage />} />
            <Route path="/admin/piese/:id/barcode" element={<BarcodeLabelPage />} />
            <Route path="/admin/vanzari/:id/print" element={<SalePrintPage />} />
            <Route path="/admin/garantii/:id/print" element={<WarrantyPrintPage />} />
            <Route path="/admin/garantii/:id/colet" element={<WarrantyBoxSheetPage />} />
            <Route path="/admin/comenzi/:id/factura" element={<InvoicePrintPage />} />
            <Route path="/admin/facturi/:id/print" element={<ManualInvoicePrintPage />} />
            <Route path="/status/:ticket" element={<PublicRepairStatus />} />
            <Route path="/garantie/:ticket" element={<WarrantyCheckPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="clienti" element={<AdminCustomers />} />
              <Route path="clienti/:id" element={<AdminCustomerDetail />} />
              <Route path="reparatii" element={<AdminRepairs />} />
              <Route path="rezervari" element={<AdminReservations />} />
              <Route path="garantii" element={<AdminWarranties />} />
              <Route path="produse" element={<AdminProducts />} />
              <Route path="comenzi" element={<AdminOrders />} />
              <Route path="facturi" element={<AdminInvoices />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="rapoarte" element={<AdminReports />} />
              <Route path="piese" element={<AdminParts />} />
              <Route path="scan" element={<AdminScanMode />} />
              <Route path="scan-test" element={<AdminScanTest />} />
              <Route path="vanzari" element={<AdminSales />} />
              <Route path="utilizatori" element={<AdminUsers />} />
              <Route path="sms" element={<AdminSmsLog />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
